module.exports = __webpack_public_path__ + "static/billsbot-row-8a3a1b993f1ce639d9b05a71ab2a1b3c.svg";